function recordsStructurallyEqual(a, b) {
  if (a === b) return true;
  if (!a || !b) return false;
  try {
    return JSON.stringify(a) === JSON.stringify(b);
  } catch {
    return false;
  }
}

/**
 * Diff two document snapshots into tldraw store change bags for buildBoardDocumentOps.
 * pin-card records are already stripped from extractBoardDocumentSnapshot.
 */
export function diffDocumentSnapshots(before, after) {
  const prev = before?.store && typeof before.store === 'object' ? before.store : {};
  const next = after?.store && typeof after.store === 'object' ? after.store : {};
  const added = {};
  const updated = {};
  const removed = {};

  for (const [id, record] of Object.entries(next)) {
    if (!id || !record) continue;
    if (!(id in prev)) {
      added[id] = record;
      continue;
    }
    if (!recordsStructurallyEqual(prev[id], record)) {
      updated[id] = [prev[id], record];
    }
  }

  for (const [id, record] of Object.entries(prev)) {
    if (!id) continue;
    if (!(id in next)) removed[id] = record;
  }

  return { added, updated, removed };
}
